module.exports = __webpack_public_path__ + "static/img/search.78f4a098.png";